import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/api-tokens/$id/databases")({
  staticData: {
    title: "apiTokens.panel.databases",
  },
});
